<template>
  <div>
    <el-switch
      :value="value"
      @change="change($event)"
      :active-text="item.active ? item.active : '打开按钮'"
      :inactive-text="item.inactive ? item.inactive : '关闭按钮 '"
      :disabled="item.disabled"
      :active-value="item.activeValue ? activeValue : true"
      :inactive-value="item.inactiveValue ? inactiveValue : false"
      :active-color="item.activeColor ? item.activeColor : '#409EFF'"
      :inactive-color="item.inactiveColor ? item.inactiveColor : '#C0CCDA'"
      class="sr-switch"
    ></el-switch>
  </div>
</template>

<!--
  功能：SrSwitch
  汪振涛
  时间：2020年11月19日 17:23:21
  版本：v1.0
-->
<script>
export default {
  name: "SrSwitch",
  model: {
    prop: "value",
    event: "change",
  },
  components: {},
  props: {
    value: String | Number | Boolean,
    item: {
      type: Object,
      defalut: {},
    },
  },
  data() {
    return {};
  },
  methods: {
    change(val) {
      this.$emit("change", val);
    },
  },
};
</script>



// WEBPACK FOOTER //
// packages/SrSwitch/SrSwitch.vue